
import { getProject } from "./project.selector";
import { createSelector } from "reselect";
import { dockPadEntityMapToList } from "../containers/DockPadFormTemplates";
import { Trade } from "../models/Trade";
import { PhasePlan, PhasePlanStatus } from "../models/PhasePlan";
import { createDeepEqualSelector, isIterable, getLocationPathName } from "./util.selector";
import { Project } from "../models/Project";
import { Constraint } from "../models/Constraint";
import { PhaseTag } from "../models/PhaseTag";
import { TagType, SelectedTag } from "../models/ TagType";
import { getLookaheadConstraints, getSelectedLookaheadTags, getLookaheadTrades, getSelectedLookaheadId } from "./lookahead.selector";
import { Point } from "../modules/ui.reducer";
const _ = require('lodash');


const getDefaultSelectedPhasePlanId = (state:any) => state.phasePlanReducer.selectedPhasePlan

export const getPhasePlans = createDeepEqualSelector([getProject], (project:Project) => {

    if (!project || !project.phases) return {}
    return project.phases
})

export const hasPhasePlans = createDeepEqualSelector([getPhasePlans], (phases: Record<string, PhasePlan>) => {
    return Object.keys(phases).length > 1
})

export const hasStartedPhasePlan = createDeepEqualSelector([getPhasePlans], (phases: Record<string, PhasePlan>) => {
    let foundStarted = false
    Object.values(phases).forEach(phase => {
        if(phase.status === PhasePlanStatus.Started) {
            foundStarted = true
        }
    })

    return foundStarted
})

export const getPhasePlanSelectedPhasePlanId = createDeepEqualSelector(
    [getProject, getDefaultSelectedPhasePlanId], 
    (project, defaultSelectedId) => {
        console.log('no phase planz')

        if (!project || !project.phases) return

        const phasePlans = project.phases

        if(!!defaultSelectedId && !!project.phases[defaultSelectedId]) {
            return defaultSelectedId
        }

        const phaseplanKeys = Object.keys(phasePlans)
        if(!!phaseplanKeys) {
            return phaseplanKeys[0]
        }

        console.log('no phase plan')

        return
    })

export const getSelectedPhasePlanId = createDeepEqualSelector(
    [
        getLocationPathName, 
        getPhasePlanSelectedPhasePlanId, 
        getSelectedLookaheadId
    ], (pathName, phasePlanId, lookaheadId) => {
        if(pathName === '/phasePlan') { 
            return phasePlanId
        }

        if(pathName === '/lookahead') {
            return lookaheadId
        }
        
        return ""
})

export const getSelectedPhasePlan = createSelector(
    [getPhasePlans, getSelectedPhasePlanId], 
    (phasePlans: Record<string, PhasePlan>, selectedPhasePlanId:string) => {

        const phasePlan = phasePlans[selectedPhasePlanId]
        return phasePlan
    })

export const getPhaseTags = createDeepEqualSelector(
    [(state:any) => 
        _.get(state, 'firebase.data.SELECTED_PHASE_TAGS')], (tags: Record<string, PhaseTag>) => {
    
    if(!tags) {
        return null
    }

    return tags
})

export const getPhaseConstraints = createDeepEqualSelector(
    [(state:any) => 
        _.get(state, 'firebase.data.SELECTED_PHASE_CONSTRAINT_TAGS')], (constraints: Record<string, Constraint>) => {

    if(!constraints) {
        return null
    }

    return constraints
})

let oldTrades = {}

export const getTrades = createDeepEqualSelector([getSelectedPhasePlan],
    (phasePlan) => {
        if (!phasePlan || !phasePlan.trades) return {} as Record<string, Trade>

        oldTrades = phasePlan.trades

        return phasePlan.trades as Record<string, Trade>
    }
)

export const getTradesList = createDeepEqualSelector([getTrades], (trades: Record<string, Trade>) => 
    dockPadEntityMapToList(trades))

export const getConstraints = createDeepEqualSelector([getSelectedPhasePlan, getLocationPathName, getLookaheadConstraints],
    (phasePlan, pathName:string, lookaheadConstraints) => {
        if(pathName === '/phasePlan') { 
            if (!phasePlan || !phasePlan.constraints) return {} as Record<string, Constraint>

            return phasePlan.constraints as Record<string, Constraint>
        }

        if(pathName === '/lookahead') {
            return lookaheadConstraints
        }

    }
)

export const getConstraintsList = createDeepEqualSelector([getConstraints], (constraints: Record<string, Constraint>) => 
    dockPadEntityMapToList(constraints))

export const getTagsList = createSelector([getPhaseTags], (tags) => {

    return dockPadEntityMapToList(tags)
})


export const getTradeId  = (state:any) => state.dialogReducer.tradeToEditId

export const getTrade = createSelector([getLocationPathName, getLookaheadTrades, getTrades, getTradeId], (pathName, lookaheadTrades, trades, tradeId) => {
    if(!tradeId) {
        return null
    }    

    if(pathName === '/phasePlan') { 
        return trades[tradeId]
    }

    if(pathName === '/lookahead') {
        return lookaheadTrades[tradeId]
    }

    return {}
})

export const getTagId  = (state:any) => state.dialogReducer.tagToEditId


export const getTag = createSelector([getPhaseTags, getTagId], (tags, tagId) => {
    if(!tagId || !tags) {
        return null
    }    

    return tags[tagId]
})

export const getPhaseTagConstraint = createSelector([getTagId, getConstraintsList], (tagId, constraints) => {

    if(!constraints) {
        return null
    }
    const constraintsByTagId = _.keyBy(constraints, 'tagId')
    return constraintsByTagId[tagId]
})


export const getConstraintId = (state:any) => state.dialogReducer.constraintId

export const getConstraint = createSelector([getConstraints, getConstraintId], (constraints, constraintId) => {
    if(!constraintId || !constraints) {
        return null
    }    

    return constraints[constraintId]
})

export const getTradesSelectList = createSelector([getTradesList], (tradesList) => {

    return tradesList.map(trade => {
        return {
            uid: trade.uid,
            name: trade.name
        }
    })
})

export const getTagSelectList = createSelector([getTagsList], (tagList) => {
    return tagList.map(tag => {
        return {
            uid: tag.uid,
            name: tag.name
        }
    })
})

export const getConstraintSelectList = createSelector([getConstraintsList], (constraintList) => {
    return constraintList.map(contraint => {
        return {
            uid: contraint.constraintId,
            name: contraint.name
        }
    })
})

export const getTagsLocations = createSelector([getTagsList], (tagList) => {
    return Object.keys(_.groupBy(tagList, 'locationId'))
})

export const getTagLocationsSelectList = createSelector([getTagsList], (tagList) => {
    return Object.keys(_.groupBy(tagList, 'locationId')).map(locationId => {
        return {
            uid: locationId,
            name: locationId
        }
    })
})

export const getTradeFilter  = (state:any) => state.phasePlanReducer.tradeFilter
  
export const getTagsByColumns =  createSelector([getPhaseTags, getPhaseConstraints, getTradeFilter], (tags, constraints, tradeFilter) => {
    const tagList: PhaseTag[] = dockPadEntityMapToList(tags).map(tag => {
        tag.tagCardType = TagType.PhasePlan
        return tag
    })

    const constraintList = dockPadEntityMapToList(constraints).map(constraint => {
        constraint.tagCardType = TagType.Constraint

        return constraint
    })

    if(!!tradeFilter) {
        const filteredTagList = tagList.filter(tag => tag.tradeId == tradeFilter.uid)
        return _.groupBy([...filteredTagList, ...constraintList], 'column')
    }

    return _.groupBy([...tagList, ...constraintList], 'column')
})

export const getPhasePlanLargestRowsPerColumns =  createDeepEqualSelector([getTagsByColumns], (tagsByColumn: Record<any, any[]>) => {
    return Object.values(tagsByColumn).reduce((obj, cur)=> {
        if(!!cur) {
            obj += cur.length
        }

        return obj
    }, 1)
})

export const hasBacklog = createDeepEqualSelector([getTagsByColumns], (tagsByColumn) => {
    if(!tagsByColumn) {
        return false
    }

    if(!!tagsByColumn['undefined']) {
        return true
    }

    return false
})

export const getOffDays =  (state:any) => {
    const offDays = state.phasePlanReducer.offDays

    if(!offDays || !isIterable(offDays)) {
        return new Set<number>()
    }

    return new Set<number>(offDays)
}

export const getLookaheadLength = (state:any) => {
    const lookaheadLength = state.phasePlanReducer.lookaheadLength

    return lookaheadLength
}


export const getMilestones = createSelector([getSelectedPhasePlan], (phasePlan) => {
    if (!phasePlan || !phasePlan.locations) return {}

    return phasePlan.locations
})

export const getPullInfo = createSelector([getSelectedPhasePlan], (phasePlan) => {
    if (!phasePlan || !phasePlan.pullInfo) return null

    return phasePlan.pullInfo
})

export const getRipTagId = (state:any) => state.dialogReducer.ripTagId

export const getRipTag = createSelector([getPhaseTags, getRipTagId], (tags: Record<string, PhaseTag> | null, tagId:string) => {
    if(!tags) {
        return
    }
    
    const tag = tags[tagId]

    if(!tag) {
        return
    }

    return tag
})

export const getSelectedPhasePlanTags  = (state:any):Record<string, SelectedTag> => !!state.phasePlanReducer.selectedTags ? state.phasePlanReducer.selectedTags : {}

export const isPhasePlanHistogramOpen = (state:any) => {
    const { isHistogramOpen } = state.phasePlanReducer

    if(!isHistogramOpen) return false

    return isHistogramOpen
}


export const getSelectedPhasePlanColumn = (state:any): Point => state.uiReducer.phasePlanColumnSelected

export const isConstraintLogDialogOpen =(state:any) => state.dialogReducer.isConstraintLogDialogOpen
export const isVarianceLogDialogOpen =(state:any) => state.dialogReducer.isVarianceLogDialogOpen

export const isCommitDialogOpen = (state:any) => state.dialogReducer.isCommitDialogOpen

export const isHuddleSettingDialogOpen = (state: any) => state.dialogReducer.isHuddleSettingDialogOpen

export const isPrintBoardOpen = (state:any) => state.dialogReducer.isPrintBoardOpen

export const isEndCommitmentDialogOpen = (state:any) => state.dialogReducer.isEndCommitmentDialogOpen
export const isVarianceDialogOpen = (state:any) => state.lookaheadReducer.isVarianceDialogOpen
export const isSetPullDateDialogDialogOpen = (state:any) => state.lookaheadReducer.isSetPullDateDialogDialogOpen

export const isDeletePPCDialogOpen = (state:any) => state.lookaheadReducer.isDeletePPCDialogOpen
export const getDeletePPCId = (state:any) => state.lookaheadReducer.deletePPCId

export const getSelectedTags = createDeepEqualSelector([getLocationPathName, getSelectedPhasePlanTags, getSelectedLookaheadTags], (pathName:string, phaseTags, lookaheadTags) => {
    if(pathName === '/phasePlan') { 
        return phaseTags
    }

    if(pathName === '/lookahead') {
        return lookaheadTags
    }
})

export const  getMaxColumnFromPhaseTags =  createDeepEqualSelector([getTagsByColumns], (tags: Record<number, any>): number => {
    if(!tags || Object.keys(tags).filter(column => column !== "undefined" && column !== "Invalid date").length <= 0) {
        return -1
    }

    const maxBasedOnColumn = Math.max.apply(null, Object.keys(tags).filter(column => column !== "undefined" && column !== "Invalid date").map(i => parseInt(i, 10)))

    return maxBasedOnColumn + 28
})




// WEBPACK FOOTER //
// ./src/selectors/phaseplan.selector.tsx